module.exports = __webpack_public_path__ + "fonts/SamsungOne-600v10.db7864df.woff";